var render = function render(){
  var _vm$getEvent$name, _vm$getEvent;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "navigation-wrapper"
  }, [_vm.isMobile && !_vm.isOpen ? _c('button', {
    staticClass: "mobile-menu-trigger",
    attrs: {
      "type": "button",
      "aria-label": "Open navigation"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "bars",
      "size": "lg",
      "color": "#fff"
    }
  })], 1) : _vm._e(), _c('transition', {
    attrs: {
      "name": "mobile-backdrop"
    }
  }, [_vm.isMobile && _vm.isOpen ? _c('div', {
    staticClass: "mobile-backdrop",
    on: {
      "click": _vm.close
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "side-bar",
    class: {
      open: _vm.isOpen
    }
  }, [_c('b-row', {
    staticClass: "m-0",
    attrs: {
      "align-h": _vm.isOpen ? 'between' : 'center',
      "align-v": "center"
    }
  }, [_c('a', {
    staticClass: "logo-link",
    class: {
      visible: _vm.isOpen
    },
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOpen,
      expression: "isOpen"
    }],
    staticClass: "logo",
    attrs: {
      "src": require("@/assets/navbar/logo.svg")
    }
  })]), _c('div', {
    staticClass: "clickable",
    on: {
      "click": _vm.toggle
    }
  }, [_c('font-awesome-icon', {
    staticClass: "chevron-left-icon",
    class: {
      visible: _vm.isOpen
    },
    attrs: {
      "icon": "chevron-left",
      "size": "lg",
      "color": "#fff"
    }
  }), _c('font-awesome-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobile || !_vm.isOpen,
      expression: "!isMobile || !isOpen"
    }],
    attrs: {
      "icon": "bars",
      "size": "lg",
      "color": "#fff"
    }
  })], 1)]), _c('b-nav', {
    staticClass: "nav-bar",
    attrs: {
      "pills": "",
      "vertical": ""
    }
  }, [_c('div', [_c('div', [_c('nav-item', {
    attrs: {
      "title": _vm.$t('navigation.pages.dashboard'),
      "is-open": _vm.isOpen,
      "to": {
        name: 'Dashboard'
      }
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('DashboardIcon', {
          staticClass: "icon"
        })];
      },
      proxy: true
    }])
  }), _c('nav-item', {
    attrs: {
      "title": _vm.$t('navigation.pages.customer-project'),
      "is-open": _vm.isOpen,
      "to": {
        name: 'Customer-Projects'
      },
      "exact": false
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('CustomerIcon', {
          staticClass: "icon"
        })];
      },
      proxy: true
    }])
  }), _vm.user.role === 'ADMIN' ? _c('nav-item', {
    attrs: {
      "title": _vm.$t('navigation.pages.admin'),
      "is-open": _vm.isOpen,
      "to": {
        name: 'Admin'
      },
      "exact": false
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('AdminIcon', {
          staticClass: "icon"
        })];
      },
      proxy: true
    }], null, false, 1908679786)
  }) : _vm._e()], 1), _vm.$route.path.startsWith('/event/') ? _c('div', {
    staticClass: "event-flow"
  }, [_c('hr', {
    staticClass: "divider"
  }), _c('div', {
    staticClass: "event-name",
    class: {
      visible: _vm.isOpen
    }
  }, [_vm._v(" " + _vm._s((_vm$getEvent$name = (_vm$getEvent = _vm.getEvent) === null || _vm$getEvent === void 0 ? void 0 : _vm$getEvent.name) !== null && _vm$getEvent$name !== void 0 ? _vm$getEvent$name : _vm.$t('navigation.event')) + " ")]), _c('nav-item', {
    attrs: {
      "title": _vm.$t('navigation.pages.event-flow'),
      "is-open": _vm.isOpen,
      "to": {
        name: 'Event'
      }
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('EventFlow', {
          staticClass: "icon"
        })];
      },
      proxy: true
    }], null, false, 2075413488)
  }), _c('nav-item', {
    attrs: {
      "title": _vm.$t('navigation.pages.master-data'),
      "is-open": _vm.isOpen,
      "to": {
        name: 'MasterData'
      }
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('ThreeLine', {
          staticClass: "icon"
        })];
      },
      proxy: true
    }], null, false, 982456814)
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "mt-auto mb-5"
  }, [_c('hr', {
    staticClass: "divider"
  }), _c('nav-item', {
    attrs: {
      "title": _vm.$t('navigation.pages.profile'),
      "is-open": _vm.isOpen,
      "to": {
        name: 'Profile'
      }
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('ProfileIcon', {
          staticClass: "icon"
        })];
      },
      proxy: true
    }])
  }), _c('nav-item', {
    attrs: {
      "title": _vm.$t('navigation.logout'),
      "is-open": _vm.isOpen
    },
    on: {
      "click": _vm.onLogout
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('LogoutIcon', {
          staticClass: "icon"
        })];
      },
      proxy: true
    }])
  })], 1), _c('selector', {
    staticClass: "language-selector justify-content-center",
    class: {
      visible: _vm.isOpen
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }